import { useMemo } from "react";
import { useNichesStore } from "@/common/store/storeNiches";
import { Image } from "@/components/UI/Image";
import { onOpenGifNichesPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import "./GifNiches.scss";
import { useSfw } from "@/common/hooks/useSfw";
import type { INiche } from "@/common/services/types";

interface IGifNiches {
  niches: string[];
}

const MAX_NICHES = 5;

export const GifNiches = ({ niches }: IGifNiches) => {
  const storeNiches = useNichesStore(state => state.niches);
  const { sanitizeNiche } = useSfw();

  // TODO: Handle case where we have more than MAX_NICHES (should edit niches qty)
  const fullNiches = useMemo<INiche[]>(() => {
    return niches.reduce<INiche[]>((acc, id) => {
      const niche = storeNiches[id];
      if (!niche) {
        return acc;
      }

      acc.push(sanitizeNiche(niche));
      return acc;
    }, []).slice(0, MAX_NICHES);
  }, [niches, storeNiches, sanitizeNiche]);

  const onOpenNiches = () => {
    onOpenGifNichesPopup({ niches: fullNiches });
  };

  return (
    <div className="gifNiches">
      <div className="nichesThumbs">
        {fullNiches.map((niche) => (
          <div className="nicheThumb" key={niche.id}>
            <Image src={niche.thumbnail} alt={niche.name} />
          </div>
        ))}
      </div>
      <button className="exploreNichesBtn" onClick={onOpenNiches}>{fullNiches.length} Niche{fullNiches.length === 1 ? "" : "s"}</button>
      <span className="nichesText">you might like</span>
    </div>
  );
};
